import { OWNERS, MODULE_STATUS } from "@/data/productOptions";

export const moduleFields = (planetOptions) => [
  { name: "name", label: "Module name", type: "text", placeholder: "e.g. The Mystery of the Ocean Compass", required: true },
  { name: "planet_id", label: "Planet", type: "select", placeholder: "Assign to a planet", options: planetOptions },
  { name: "main_character", label: "Main character", type: "text", placeholder: "e.g. Captain Hightides" },
  { name: "owner", label: "Owner", type: "select", placeholder: "Owner", options: OWNERS, required: true },
  { name: "status", label: "Status", type: "select", placeholder: "Status", options: MODULE_STATUS, required: true },
  { name: "completion", label: "Completion %", type: "text", placeholder: "0 - 100" },
  { name: "planned_chapters", label: "Planned chapters", type: "text", placeholder: "e.g. 3" },
  { name: "target_date", label: "Target completion date", type: "date" },
  { name: "description", label: "Short description", type: "textarea", placeholder: "What is this module about?" },
  { name: "learning_objectives", label: "Learning objectives", type: "textarea", placeholder: "What will learners take away?" },
  { name: "current_blocker", label: "Current blocker", type: "textarea", placeholder: "Anything blocking progress?" },
  { name: "next_action", label: "Next action", type: "textarea", placeholder: "What happens next?" },
  { name: "notes", label: "Notes", type: "textarea", placeholder: "Any other detail" },
];
